class WithdrawalFunction {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('form.withdrawal-form');
    this.receipt = section.querySelector('[data-withdrawal-receipt]');
    this.storageKey = 'ngt-withdrawal-submission';

    if (this.form) this.initForm();
    if (this.receipt) this.initReceipt();
  }

  initForm() {
    this.detailsStep = this.form.querySelector('[data-withdrawal-step="details"]');
    this.reviewStep = this.form.querySelector('[data-withdrawal-step="review"]');
    this.partialItems = this.form.querySelector('[data-partial-items]');
    this.itemsInput = this.form.querySelector('[name="contact[Preces vai pakalpojumi]"]');

    this.form.querySelector('[data-withdrawal-next]')?.addEventListener('click', () => this.showReview());
    this.form.querySelector('[data-withdrawal-back]')?.addEventListener('click', () => this.showDetails());
    this.form.querySelectorAll('[name="contact[Atteikuma apjoms]"]').forEach((input) => {
      input.addEventListener('change', () => this.togglePartialItems());
    });
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    this.togglePartialItems();

    const orderFromUrl = new URLSearchParams(window.location.search).get('order');
    const orderInput = this.form.querySelector('[name="contact[Pasūtījuma numurs]"]');
    if (orderFromUrl && orderInput && !orderInput.value) orderInput.value = orderFromUrl;
  }

  togglePartialItems() {
    const selected = this.form.querySelector('[name="contact[Atteikuma apjoms]"]:checked')?.value;
    const isPartial = selected === 'Tikai norādītās preces vai pakalpojumi';
    if (this.partialItems) this.partialItems.hidden = !isPartial;
    if (this.itemsInput) this.itemsInput.required = isPartial;
  }

  showReview() {
    if (!this.form.reportValidity()) return;

    const data = this.collectData();
    this.reviewStep.querySelector('[data-review-name]').textContent = data.name;
    this.reviewStep.querySelector('[data-review-email]').textContent = data.email;
    this.reviewStep.querySelector('[data-review-order]').textContent = data.order;
    this.reviewStep.querySelector('[data-review-scope]').textContent = data.scope;
    this.reviewStep.querySelector('[data-review-items]').textContent = data.items || '—';
    this.detailsStep.hidden = true;
    this.reviewStep.hidden = false;
    this.setCurrentStep(2);
    this.reviewStep.querySelector('h2')?.focus();
  }

  showDetails() {
    this.reviewStep.hidden = true;
    this.detailsStep.hidden = false;
    this.setCurrentStep(1);
    this.detailsStep.querySelector('input')?.focus();
  }

  setCurrentStep(step) {
    this.section.querySelectorAll('[data-progress-step]').forEach((item, index) => {
      if (index + 1 === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }

  collectData() {
    const data = new FormData(this.form);
    return {
      name: data.get('contact[Vārds un uzvārds]')?.toString().trim() || '',
      email: data.get('contact[email]')?.toString().trim() || '',
      order: data.get('contact[Pasūtījuma numurs]')?.toString().trim() || '',
      scope: data.get('contact[Atteikuma apjoms]')?.toString() || '',
      items: data.get('contact[Preces vai pakalpojumi]')?.toString().trim() || ''
    };
  }

  handleSubmit(event) {
    if (this.reviewStep?.hidden) {
      event.preventDefault();
      this.showReview();
      return;
    }

    const data = this.collectData();
    const submittedAt = new Date();
    const reference = `NGT-${submittedAt.toISOString().replace(/\D/g, '').slice(0, 14)}-${Math.random()
      .toString(36)
      .slice(2, 6)
      .toUpperCase()}`;
    const payload = {
      ...data,
      submittedAt: submittedAt.toISOString(),
      submittedAtDisplay: submittedAt.toLocaleString('lv-LV', { dateStyle: 'long', timeStyle: 'long' }),
      reference
    };
    const statement = [
      'PATĒRĒTĀJA PAZIŅOJUMS PAR ATTEIKŠANOS NO LĪGUMA',
      `Apliecinājuma numurs: ${reference}`,
      `Iesniegts: ${payload.submittedAtDisplay} (${payload.submittedAt})`,
      `Vārds un uzvārds: ${data.name}`,
      `E-pasts apliecinājumam: ${data.email}`,
      `Pasūtījuma numurs: ${data.order}`,
      `Atteikuma apjoms: ${data.scope}`,
      `Preces vai pakalpojumi: ${data.items || 'viss pasūtījums'}`,
      '',
      'Ar šo nepārprotami paziņoju, ka izmantoju tiesības atteikties no iepriekš norādītā distances līguma.'
    ].join('\n');

    const body = this.form.querySelector('[data-withdrawal-body]');
    const referenceInput = this.form.querySelector('[data-withdrawal-reference]');
    if (body) body.value = statement;
    if (referenceInput) referenceInput.value = reference;

    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(payload));
    } catch (error) {
      // The form still submits if browser storage is unavailable.
    }
  }

  initReceipt() {
    let payload = null;
    try {
      payload = JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (error) {
      payload = null;
    }

    const fallbackTime = this.receipt.dataset.fallbackTime;
    const receiptData = payload || {
      reference: '—',
      submittedAtDisplay: fallbackTime,
      name: '—',
      email: '—',
      order: '—',
      scope: '—',
      items: '—'
    };

    Object.entries(receiptData).forEach(([key, value]) => {
      const output = this.receipt.querySelector(`[data-receipt-${key}]`);
      if (output) output.textContent = value || '—';
    });

    this.receipt.querySelector('[data-download-receipt]')?.addEventListener('click', () => {
      this.downloadReceipt(receiptData);
    });
    this.receipt.querySelector('[data-print-receipt]')?.addEventListener('click', () => window.print());
  }

  downloadReceipt(data) {
    const storeName = this.section.dataset.storeName || 'NGT Latvia';
    const content = [
      'APLIECINĀJUMS PAR ATTEIKUMA PAZIŅOJUMA SAŅEMŠANU',
      '',
      `Tirgotājs: ${storeName}`,
      `Apliecinājuma numurs: ${data.reference}`,
      `Iesniegts: ${data.submittedAtDisplay}`,
      `Vārds un uzvārds: ${data.name}`,
      `E-pasts: ${data.email}`,
      `Pasūtījuma numurs: ${data.order}`,
      `Atteikuma apjoms: ${data.scope}`,
      `Preces vai pakalpojumi: ${data.items || 'viss pasūtījums'}`,
      '',
      'Statuss: atteikuma paziņojums ir saņemts.',
      'Paziņojums: patērētājs nepārprotami paziņoja par atteikšanos no iepriekš norādītā distances līguma.'
    ].join('\r\n');
    const blob = new Blob(['\uFEFF', content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `atteikuma-apliecinajums-${data.reference || 'NGT'}.txt`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
}

document.querySelectorAll('[data-withdrawal-function]').forEach((section) => new WithdrawalFunction(section));
